/**
 * 사이드바 로고 섹션 컴포넌트
 */ import React from 'react';
import * as m from "@paraglide/messages";
import { X } from 'lucide-react';
export const LogoSection = ({ logoText, logoImage, onLogoClick, isTabletView, isMobileSidebar, isIconOnlyMode, onClose, logoTextStyle })=>{
    const defaultLogoText = logoText || m.common_appName();
    const handleLogoClick = ()=>{
        if (onLogoClick) {
            onLogoClick();
        }
    };
    const isCompactMode = !isMobileSidebar ? typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView : false;
    const baseLogoTextStyle = {
        fontSize: isMobileSidebar ? '1.125rem' : '1.5rem',
        fontWeight: '800',
        margin: isMobileSidebar ? '0' : '0 0 1rem 0',
        color: '#111827',
        letterSpacing: '-0.025em',
        cursor: onLogoClick ? 'pointer' : 'default',
        transition: 'opacity 0.2s ease',
        display: 'flex',
        alignItems: 'center'
    };
    const mergedLogoTextStyle = {
        ...baseLogoTextStyle,
        ...logoTextStyle
    };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            marginBottom: '2rem',
            width: '100%',
            display: 'flex',
            flexDirection: isMobileSidebar ? 'row' : 'column',
            alignItems: isMobileSidebar ? 'center' : 'flex-start',
            justifyContent: isMobileSidebar ? 'space-between' : 'flex-start',
            padding: isMobileSidebar ? '0 1rem 0 1rem' : '0'
        }
    }, isCompactMode ? /*#__PURE__*/ React.createElement("div", {
        onClick: handleLogoClick,
        style: {
            width: '48px',
            height: '48px',
            borderRadius: logoImage ? '50%' : '12px',
            background: logoImage ? 'transparent' : 'linear-gradient(135deg, var(--primary, #3b82f6) 0%, var(--primary-dark, #2563eb) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1rem',
            color: 'white',
            fontWeight: '900',
            fontSize: '1.25rem',
            cursor: onLogoClick ? 'pointer' : 'default',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            overflow: 'hidden'
        },
        onMouseEnter: (e)=>{
            if (onLogoClick) {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.3)';
            }
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
        },
        title: defaultLogoText
    }, logoImage ? /*#__PURE__*/ React.createElement("img", {
        src: logoImage,
        alt: defaultLogoText,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    }) : defaultLogoText.substring(0, 2).toUpperCase()) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h2", {
        onClick: handleLogoClick,
        style: mergedLogoTextStyle,
        onMouseEnter: (e)=>{
            if (onLogoClick) {
                e.currentTarget.style.opacity = '0.8';
            }
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.opacity = '1';
        }
    }, logoImage && /*#__PURE__*/ React.createElement("img", {
        src: logoImage,
        alt: defaultLogoText,
        style: {
            width: isMobileSidebar ? '24px' : '32px',
            height: isMobileSidebar ? '24px' : '32px',
            marginRight: '0.5rem'
        }
    }), defaultLogoText), isMobileSidebar && onClose && /*#__PURE__*/ React.createElement("button", {
        onClick: onClose,
        style: {
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0.5rem',
            color: '#6b7280',
            transition: 'color 0.2s ease',
            marginRight: '0'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.color = '#374151';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.color = '#6b7280';
        }
    }, /*#__PURE__*/ React.createElement(X, {
        size: 24
    }))));
};
